import React from 'react';

const TabNavigation = ({ activeTab, onTabChange, videosCount, rappersCount, usersCount }) => {
  return (
    <div className="flex flex-nowrap overflow-x-auto space-x-4 mb-6 border-b border-gray-800 scrollbar-hide -mx-4 px-4 sm:mx-0 sm:px-0">
      <button
        onClick={() => onTabChange('videos')}
        className={`pb-2 px-4 whitespace-nowrap flex-shrink-0 ${
          activeTab === 'videos'
            ? 'border-b-2 border-brand-yellow text-white'
            : 'text-gray-400'
        }`}
        data-testid="videos-tab"
      >
        Videos ({videosCount})
      </button>
      <button
        onClick={() => onTabChange('rappers')}
        className={`pb-2 px-4 whitespace-nowrap flex-shrink-0 ${
          activeTab === 'rappers'
            ? 'border-b-2 border-brand-yellow text-white'
            : 'text-gray-400'
        }`}
        data-testid="rappers-tab"
      >
        Rappers ({rappersCount})
      </button>
      <button
        onClick={() => onTabChange('users')}
        className={`pb-2 px-4 whitespace-nowrap flex-shrink-0 ${
          activeTab === 'users'
            ? 'border-b-2 border-brand-yellow text-white'
            : 'text-gray-400'
        }`}
        data-testid="users-tab"
      >
        Users ({usersCount || 0})
      </button>
      <button
        onClick={() => onTabChange('stats')}
        className={`pb-2 px-4 whitespace-nowrap flex-shrink-0 ${
          activeTab === 'stats'
            ? 'border-b-2 border-brand-yellow text-white'
            : 'text-gray-400'
        }`}
        data-testid="stats-tab"
      >
        Statistics
      </button>
    </div>
  );
};

export default TabNavigation;
